import { render, staticRenderFns } from "./BackendLicenseOverview.vue?vue&type=template&id=b35a6bee&scoped=true&lang=pug"
import script from "./BackendLicenseOverview.vue?vue&type=script&lang=js"
export * from "./BackendLicenseOverview.vue?vue&type=script&lang=js"
import style0 from "./BackendLicenseOverview.vue?vue&type=style&index=0&id=b35a6bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a6bee",
  null
  
)

export default component.exports